import { ReactElement } from 'react';
import { CopiedWrapper, CopiedText, CopiedIcon, CopiedMobileIcon } from './CopiedVariant.styles';
import { CopiedVariantProps } from './CopiedVariant.types';

export const CopiedVariant = ({ linkAsIcon }: CopiedVariantProps): ReactElement => {
  return !linkAsIcon ? (
    <CopiedWrapper>
      <CopiedIcon />
      <CopiedText>Link copied to clipboard</CopiedText>
    </CopiedWrapper>
  ) : (
    <CopiedMobileIcon />
  );
};
